import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { DropdownSearchMultipleComponent } from '@irb-common/components/dropdown-search-multiple/dropdown-search-multiple.component';
import { MatchComponent } from '@irb-common/components/grid/renderers/match.cell.component';
import { SelectionCellComponent } from '@irb-common/components/grid/renderers/selection.cell.component';

@Injectable({
    providedIn: 'root'
})
export class DropdownSearchMultipleGridLayoutService implements GridLayoutService<DropdownSearchMultipleComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {
            "MatchComponent": MatchComponent,
            "SelectionCellComponent": SelectionCellComponent
        };
    }

    getColumnDefs() {
        return [{
            width: 30,
            minWidth: 30,
            cellRenderer: "SelectionCellComponent",
            cellRendererParams: {type: 'checkbox'},
            suppressKeyboardEvent: (_params: any) => {
                return true;
            },
            sortable: false,
            cellClass: 'ddMultiSearchCheckBoxColumn'
        },{
            headerName: 'Name',
            field: 'name',
            cellRenderer: "MatchComponent",
            suppressKeyboardEvent: (_params: any) => {
                return true;
            },
            sortable: false,
            flex: 1
        }];
    }
}
